import './action-bar.scss'
import { BsArrowCounterclockwise } from 'react-icons/bs'

interface ActionBarProps {
  isDirty: boolean
  isPublishing: boolean
  onDiscard: () => void
  onPublish: () => void
}

export function ActionBar({ isDirty, isPublishing, onDiscard, onPublish }: ActionBarProps) {
  return (
    <div className='Stat__action-bar' role='region' aria-label='Publish controls'>
      <div className='Stat__action-bar__buttons'>
        <button
          type='button'
          className='Stat__action-bar__btn'
          disabled={!isDirty || isPublishing}
          onClick={onDiscard}
        >
          <BsArrowCounterclockwise aria-hidden='true' />
          Discard
        </button>
        <button
          type='button'
          className='Stat__action-bar__btn Stat__action-bar__btn--pink'
          disabled={!isDirty || isPublishing}
          onClick={onPublish}
        >
          {isPublishing && (
            <span
              className='spinner-border spinner-border-sm Stat__action-bar__spinner'
              aria-hidden='true'
            />
          )}
          {isPublishing ? 'Publishing…' : 'Publish Changes'}
        </button>
      </div>
    </div>
  )
}
